// extracted by mini-css-extract-plugin
module.exports = {"leftPanel":"needsActivation__leftPanel--ZUF87","rightPanel":"needsActivation__rightPanel--1eMDK","sendEmail":"needsActivation__sendEmail--20wdl"};